import { render } from "./AddSafetyModal.vue?vue&type=template&id=6fa4642c&scoped=true"
import script from "./AddSafetyModal.vue?vue&type=script&lang=js"
export * from "./AddSafetyModal.vue?vue&type=script&lang=js"

import "./AddSafetyModal.vue?vue&type=style&index=0&id=6fa4642c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa4642c"]])

export default __exports__